export class LaunchDataVO {
	public objectType: string;
	public id: string;
	public name: string;
	public contextActivities: any;
	public grouping: any;
	public sessionid: string;
	public launchMode: string;
	public returnURL: string;
	public launchMethod: string; //Normal, Browse, review
	public masteryScore: string;
	public moveOn: string;
	public launchParameters: any;
	public clientKey: string;
}
